module.exports = __webpack_public_path__ + "static/media/visitorPif.b68185e4.jpg";